export enum RoleType {
    BASIC = 'Básico',
    MANAGER = 'Gerente',
    ADMIN = 'Admin',
    SEPERADMIN = 'SuperAdmin',
}

